import React, {Component} from 'react';
import {Form} from './Form';
import {OperationSummary} from './OperationSummary';
import {Balances} from './Balances';
import {OperationType} from "buenLib/domain/OperationType";
import 'assets/sass/dashboard/buy-and-sell/BuyAndSell.scss';

export const BUY_AND_SELL_CONFIGURATION_STEP = 'configuration';
export const BUY_AND_SELL_SUMMARY_STEP = 'summary';

export class BuyAndSell extends Component {
    renderOperationStep() {
        switch (this.props.operationStep) {
            case BUY_AND_SELL_CONFIGURATION_STEP:
                return <Form data={this.props.data}
                             operationForm={this.props.operationForm}
                             handleInputChange={this.props.handleOperationAmountChange}
                             handleContinue={this.props.handleOperationStepChange}
                             balanceAndLimitsLoading={this.props.balanceAndLimitsLoading}
                />;
            case BUY_AND_SELL_SUMMARY_STEP:
                return <OperationSummary data={this.props.data}
                                         operationForm={this.props.operationForm}
                                         handleOperationConfirm={this.props.handleOperationConfirm}
                                         loading={this.props.processOrderLoading}/>;
            default:
                return <Form operation={this.props.operation}
                             handleInputChange={this.props.handleOperationAmountChange}
                             handleContinue={this.props.handleOperationStepChange}
                             balanceAndLimitsLoading={this.props.balanceAndLimitsLoading}
                />;
        }
    }

    render() {
        const operationForm = this.props.operationForm;
        const balance = this.props.data.balance;

        return (
            <div className="buy-and-sell">
                <div className="buy-and-sell-main">
                    <div className="buy-and-sell-content">
                        <div className="d-block d-lg-none">
                            <Balances balance={balance} currenciesToShow={[operationForm.bidCurrency(), operationForm.askCurrency()]}/>
                        </div>
                        {this.renderOperationStep()}
                    </div>
                </div>
                <div className="d-none d-lg-block">
                    <Balances balance={balance} currenciesToShow={[operationForm.bidCurrency(), operationForm.askCurrency()]}/>
                </div>
            </div>
        );
    }
}
